module.exports = __webpack_public_path__ + "img/25.7e0c9b17.jpg";